import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';

// Redux
import { useDispatch } from 'react-redux';
import { setUserProfile } from '../../Reducers/userProfileReducer';

// Router
import { useHistory } from 'react-router-dom';

// Components
import SideBar from './Common/SideBar';
import DashboardHeader from './Common/DashboardHeader';
import DashboardContent from './Common/DashboardContent';
import { Footer } from 'antd/es/layout/layout';

import './index.scss';
import { getUserById } from '../../Constants/Api/functions/function';

const Dashboard = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [userData, setUserData] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        const storedUser = localStorage.getItem('digital-academy-user')
        if (!storedUser) {
            history.push('/login')
            return
        }

        try {
            const user = JSON.parse(storedUser)
            // Handle both old format { success, message, user: {...} } and new format { id, ... }
            const userData = user.user || user

            if (userData && userData.id) {
                hnadlegetUserById(userData)
            } else {
                localStorage.removeItem('digital-academy-user')
                history.push('/login')
            }
        } catch (error) {
            console.error('Error parsing user from localStorage:', error)
            localStorage.removeItem('digital-academy-user')
            history.push('/login')
        }
    }, [])

    const hnadlegetUserById = async (user) => {
        try {
            if (!user || !user.id) {
                history.push('/login')
                return
            }
            const response = await getUserById(user.id)
            if (response && response.id) {
                setUserData(response)
                dispatch(setUserProfile(response))
                localStorage.setItem('digital-academy-user', JSON.stringify(response))
            } else {
                history.push('/login')
            }
        } catch (error) {
            console.log('handlegetUserById -> error', error)
            history.push('/login')
        }
    }

    return (
        <Layout className='dashboard'>
            {
                userData ?
                    <>
                        <SideBar
                            userData={userData}
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}
                        />
                        <Layout
                            onClick={() => {
                                if (window.innerWidth < 768) {
                                    if (!collapsed) {
                                        setCollapsed(true);
                                    }
                                }
                            }}
                        >
                            <div
                                className={!collapsed ? 'dark-overlay' : 'dark-overlay-active'}
                            ></div>
                            <DashboardHeader />
                            <DashboardContent />
                            <Footer className='footer-dashboard'>
                                <p>
                                    © 2025
                                    <a
                                        href='http://tuitionpanthiya.lk/'
                                        target='_blank'
                                        rel='noreferrer'
                                    > IBAS.</a> All Rights Reserved.
                                </p>

                                <p>
                                    Designed & Developed by
                                    <a href="https://lionbit.cc/" target="_blank" rel="noreferrer">
                                        {" "}
                                        LionBit Solutions.
                                    </a>
                                </p>
                            </Footer>
                        </Layout>
                    </>
                    :
                    <div className='laoder-anim'>
                        <div class="three-body">
                            <div class="three-body__dot"></div>
                            <div class="three-body__dot"></div>
                            <div class="three-body__dot"></div>
                        </div>
                        <p>
                            Please wait
                        </p>
                    </div>
            }

        </Layout>
    )
}

export default Dashboard